export default "__VITE_ASSET__B3bztW7$__"